import { createRoot } from 'react-dom/client'
import AlertFetchSpinner from '../alertFetchSpinner/alertFetchSpinner'

const GlobalAlert = (message, spinner = false, error = false) => {
  const alertContainer = document.createElement('div')
  document.body.appendChild(alertContainer)

  const root = createRoot(alertContainer)

  const removeAlert = () => {
    root.unmount()
    document.body.removeChild(alertContainer)
  }

  root.render(<AlertFetchSpinner message={message} spinner={spinner} error={error} />)

  setTimeout(removeAlert, 4000)
}

export default GlobalAlert
